module.exports = __webpack_public_path__ + "img/IMG_9918.c5401c01.jpg";